import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { CountryISO, PhoneNumberFormat, SearchCountryField } from 'ngx-intl-tel-input';
import { forkJoin } from 'rxjs';
import { FormControlOption } from 'src/app/interfaces/form-control-option';
import { User } from 'src/app/interfaces/user';
import { AuthService } from 'src/app/services/auth.service';
import { ChatroomService } from 'src/app/services/chatroom.service';
import { ControllerService } from 'src/app/services/controller.service';
import { ValidationError } from 'src/app/utils/errors/validation-error';

type EditProfileFormFields = 'name' | 'email' | 'phone';

@Component({
  selector: 'app-modal-complete-account',
  templateUrl: './modal-complete-account.component.html',
  styleUrls: ['./modal-complete-account.component.scss'],
})
export class ModalCompleteAccountComponent implements OnInit {
  user: User;

  preferredCountries: CountryISO[] = [CountryISO.Indonesia];
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  separateDialCode = true;
  PhoneNumberFormat = PhoneNumberFormat;
  oldPhone: any;

  editProfileForm: FormGroup;

  editProfileFormControlOptions: Record<EditProfileFormFields, FormControlOption> = {
    name: {
      formControlName: 'name',
      serverField: 'name',
      rules: [
        {
          name: 'required',
          message: 'Full name required',
        },
      ],
    },
    email: {
      formControlName: 'email',
      serverField: 'email',
      rules: [
        {
          name: 'required',
          message: 'Email required',
        },
        // {
        //   name: 'email',
        //   message: 'Email harus berupa alamat email yang valid',
        // },
        {
          name: 'pattern',
          message: 'Email harus berupa alamat email yang valid',
        },
      ],
    },
    phone: {
      formControlName: 'phone',
      serverField: 'phone',
      rules: [
        {
          name: 'required',
          message: 'Nomor Telepon wajib diisi',
        },
        {
          name: 'invalid',
          message: 'Nomor Telepon telah digunakan!',
        },
      ],
    },
  };

  constructor(
    private modalController: ModalController,
    private authService: AuthService,
    private controllerService: ControllerService,
    private chatroomService: ChatroomService,
  ) {}

  ngOnInit() {
    this.getData(null);
  }

  async cancel() {
    this.modalController.dismiss(null, 'cancel');
  }

  async goToChatroom() {
    this.modalController.dismiss(null, 'chatroom');
  }

  getData(event: any) {
    const profileReq = this.authService.getProfile();
    forkJoin([profileReq]).subscribe({
      next: async ([profileRes]) => {
        this.user = profileRes.user;

        if (this.user) {
          this.editProfileForm = new FormGroup({
            name: new FormControl(this.user.name, {
              validators: [Validators.required],
            }),
            email: new FormControl(this.user.email, {
              validators: [
                Validators.required,
                // Validators.email, //no need double validation
                Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/),
              ],
            }),
            phone: new FormControl(null, {
              validators: [Validators.required],
            }),
          });

          if (this.user.phone) {
            this.editProfileForm.setValue({
              name: this.user.name,
              email: this.user.email,
              phone: this.user.phone,
            });
          }
        }
      },
      complete: () => {
        event?.target?.complete();
      },
    });
  }

  onEditProfileFormSubmit() {
    if (!this.editProfileForm.valid) {
      return;
    }

    const formData = new FormData();
    formData.append('name', this.editProfileForm.get('name').value);
    formData.append('email', this.editProfileForm.get('email').value);

    // console.log(formData);

    this.editProfile(formData);
  }

  editProfile(formData: FormData) {
    this.authService.updateProfileFormData(formData).subscribe({
      next: async (res: any) => {
        if (res) {
          console.log(res);
          this.controllerService.dismissLoading();
          await this.controllerService.presentToast(
            {
              color: 'primary',
              duration: 3000,
              message: 'Berhasil memperbarui profil anda',
            },
            true,
          );
          this.cancel();
          this.chatroomService.goToChatroomPage(
            this.editProfileForm.get('name').value,
            this.editProfileForm.get('email').value,
          );
        }
      },
      error: async err => {
        if (err instanceof ValidationError) {
          err.render(this.editProfileForm, this.editProfileFormControlOptions);
        }
        this.cancel();
        await this.controllerService.presentToast(
          {
            color: 'warning',
            duration: 3000,
            message: 'Maaf, Terjadi Kesalahan',
          },
          true,
        );
      },
    });
  }
}
